import * as React from "react";
import { withRouter } from "react-router";

import { SITE_TREE } from "../../../Constants";
import { Location, Match } from "../../../Models";
import Card from "../../General/Card";
import withTitle from "../../Hoc/withTitle";
import Welcome from "../Details/Welcome";
import PowerBiSitesReport from "../PowerBi/PowerBiSitesReport";

interface IFrontpageProps {
    location: Location;
    match: Match;
}

const Frontpage = (props: IFrontpageProps) => {
    const worldMap: boolean =
        props.location.search.indexOf("search") === -1 &&
        props.match.params.filter === SITE_TREE;
    return (
        <div
            className={`Details__content ${
                !worldMap ? "Details__content--welcome" : ""
            }`}
        >
            <div className="Details__baseData">
                {worldMap && (
                    <Card
                        title={"World site view"}
                        content={<PowerBiSitesReport />}
                    />
                )}
                {!worldMap && <Welcome />}
            </div>
        </div>
    );
};

export default withRouter(withTitle(Frontpage)) as any;
